import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const SingleFeedView = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'feed-view' */
  './SingleFeedView'
))

export function AsyncSingleFeedView(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Feed..." />}>
      <SingleFeedView {...props} />
    </Suspense>
  )
}

export default AsyncSingleFeedView
